import { render, staticRenderFns } from "./ContentLabelTreeModal.vue?vue&type=template&id=1a310f77&scoped=true&"
import script from "./ContentLabelTreeModal.vue?vue&type=script&lang=ts&"
export * from "./ContentLabelTreeModal.vue?vue&type=script&lang=ts&"
import style0 from "./ContentLabelTreeModal.vue?vue&type=style&index=0&id=1a310f77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a310f77",
  null
  
)

export default component.exports